import { render, staticRenderFns } from "./upload-file-button.vue?vue&type=template&id=815f0d7c"
import script from "./upload-file-button.vue?vue&type=script&lang=js"
export * from "./upload-file-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports